import BaseCom from "./BaseCom";
import './Logo.css';

export default class Logo extends BaseCom {
    render() {
        return <img src="/img/logo.png" alt="Bidea Online" className={'img-fluid logo' + (this.props.className ? ' ' + this.props.className : '')} />;
    }
}